import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { DepreciationType, GeneralAssetType, MaintenanceType, ProfilAssetType } from "../validations"

type PictureListType = {
    pictures: {
        asset_picture_id: string,
        asset_picture_name: string,
        asset_picture_code: string,
        description: string,
        path_picture: string
    }[]
}

type HistoriType = {
    history: {
        month: number,
        year: number,
        transaction_date: string,
        depreciation_expenses: number
    }[]
}



type DataFetching = GeneralAssetType & ProfilAssetType & DepreciationType & MaintenanceType & PictureListType & HistoriType

export const useAssetById = ({ asset_id }: { asset_id: number | undefined }) => {
    const api = useApi()
    const [data, setData] = useState<DataFetching | null>(null)
    const [isLoading, setLoading] = useState(true)

    const fetching = () => {
        api.get(`/assetdepre/get_data_asset_by_id?asset_id=${asset_id}`)
            .then((res: SuccessFetch<{ payload: DataFetching }>) => {
                setData(res.data.payload)
            })
            .catch(() => setData(null))
            .finally(() => setLoading(false))
    }

    const refecth = () => fetching()

    useEffect(() => {
        if (asset_id) {
            fetching()

            return () => {
                setData(null)
                setLoading(true)
            }
        }

        // eslint-disable-next-line
    }, [asset_id])

    return { data, isLoading, refecth }
}

